<template>
  <!-- HEADER -->
  <div class="top-bar">
    <button class="btn-back" @click="goBack">
      <i class="material-icons">arrow_back</i>
    </button>
    <h1>Equipo Editoria</h1>
  </div>

  <div class="container">

    <!-- SKELETON -->
    <div v-if="loading" class="card">
      <div class="skeleton skeleton-title"></div>
      <div class="skeleton skeleton-text"></div>
      <div class="skeleton skeleton-text"></div>
      <div class="skeleton skeleton-text short"></div>
      <div class="skeleton skeleton-text"></div>
      <div class="skeleton skeleton-text"></div>
      <div class="skeleton skeleton-text"></div>
      <div class="skeleton skeleton-text"></div>
      <div class="skeleton skeleton-text"></div>
      <div class="skeleton skeleton-text"></div>
      <div class="skeleton skeleton-text"></div>
      <div class="skeleton skeleton-text"></div>
      <div class="skeleton skeleton-text"></div>
      <div class="skeleton skeleton-text"></div>
      <div class="skeleton skeleton-text"></div>
      <div class="skeleton skeleton-text"></div>
      <div class="skeleton skeleton-text"></div>
      <div class="skeleton skeleton-text"></div>
      <div class="skeleton skeleton-text"></div>
      <div class="skeleton skeleton-text"></div>
      <div class="skeleton skeleton-text"></div>
      <div class="skeleton skeleton-text"></div>
      <div class="skeleton skeleton-text"></div>
      <div class="skeleton skeleton-text"></div>
      <div class="skeleton skeleton-text"></div>
      <div class="skeleton skeleton-text"></div>
      <div class="skeleton skeleton-text"></div>
      <div class="skeleton skeleton-text"></div>

    </div>

    <!-- CONTENIDO -->
   
      <div 
        class="content"
        v-html="editorial_team"
      ></div>
    </div>

    <!-- ERROR -->
    <p v-if="error" class="error">
      {{ error }}
    </p>

</template>

<script setup>
import { ref, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import api from '../../services/api'

const router = useRouter()

const loading = ref(true)
const editorial_team = ref('')
const error = ref('')

// CARGAR SETTINGS
const loadSettings = async () => {
  try {
    const response = await api.get('/settings')

    editorial_team.value = response.data.setting.editorial_team

  } catch (err) {
    error.value = 'No se pudo cargar el aviso legal'
    console.error(err)
  } finally {
    loading.value = false
  }
}

onMounted(() => {
  loadSettings()
})

// BACK
const goBack = () => {
  if (window.history.length > 1) {
    router.back()
  } else {
    router.push('/mizona')
  }
}
</script>

<style scoped>
.container {
  padding: 20px;
}

/* HEADER */
.top-bar {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 16px 20px;
  background: #fff;
  position: sticky;
  top: 0;
}

.btn-back {
  background: none;
  border: none;
}

.btn-back i {
  font-size: 26px;
  color: #00144a;
}

.top-bar h1 {
  font-size: 18px;
  margin: 0;
  color: #00144a;
  font-weight: 600;
}

/* CONTENIDO HTML */
.content {
  font-size: 14px;
  line-height: 1.6;
  color: #333;
}

.content h2,
.content h3,
.content h4 {
  margin-top: 15px;
}

.content p {
  margin-bottom: 10px;
}

/* ERROR */
.error {
  color: red;
  text-align: center;
  margin-top: 10px;
}

/* SKELETON */
.skeleton {
  background: #e5e7eb;
  border-radius: 6px;
  position: relative;
  overflow: hidden;
  margin-bottom: 10px;
}

.skeleton::after {
  content: '';
  position: absolute;
  width: 150%;
  height: 100%;
  left: -150%;
  top: 0;
  background: linear-gradient(90deg, transparent, rgba(255,255,255,0.6), transparent);
  animation: shimmer 1.2s infinite;
}

@keyframes shimmer {
  100% {
    left: 150%;
  }
}

.skeleton-title {
  height: 20px;
  width: 60%;
}

.skeleton-text {
  height: 12px;
}

.skeleton-text.short {
  width: 70%;
}
</style>
